import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  initBar,
  barAnimation,
  datasetYX,
  xLinear,
  yBand,
  percent,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  pivotAdapter,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotDiscreteLegend,
  pivotIndicatorsAsCol,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  barStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  horizontalCrosshairRect,
  barCornerRadius,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  pivotColorLegend,
  barMaxWidth,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
  regionPadding,
} from '../pipes'

const barPercent: VChartSpecPipeline = [
  fontFamilyTheme,
  initBar,
  barAnimation,
  regionPadding,
  barCornerRadius,
  barMaxWidth,
  colorAdapter(color, linearColor),
  backgroundColor,
  percent,
  datasetYX,
  animationMorph,
  progressive,
  xLinear,
  yBand,
  label,
  brush,
  tooltip({ titleEncoding: 'y' }),
  colorAdapter(discreteLegend, colorLegend),
  horizontalCrosshairRect,
  colorBarStyleFill(barStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

const pivotBarPercent: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsCol,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initBar,
    barAnimation,
    regionPadding,
    barCornerRadius,
    barMaxWidth,
    colorAdapter(color, linearColor),
    backgroundColor,
    percent,
    datasetYX,
    animationMorph,
    xLinear,
    pivotAxisStyle(yBand),
    brush,
    label,
    tooltip({ titleEncoding: 'y' }),
    colorBarStyleFill(barStyle),
    horizontalCrosshairRect,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const barPercentSpecPipeline = [pivotAdapter(barPercent, pivotBarPercent)]
